<pr-form (onSubmit)="submit()" [title]="title" [formGroup]="form">
  <pr-input label="Personne rattachée" [derrors]="derrors">
    <mat-select formControlName="ownerIds" [multiple]="true">
      @for (owner of gedOwners; track owner) {
        <mat-option [value]="owner.code">
          {{ owner.label }}
        </mat-option>
      }
    </mat-select>
  </pr-input>

  <pr-input
    [hidden]="!form.get('ownerIds').value"
    label="Catégorie du document"
    [derrors]="derrors"
  >
    <mat-select
      formControlName="category"
      (selectionChange)="initFormWithCategory()"
    >
      @for (category of gedCategories; track category) {
        <mat-option [value]="category.code">
          {{ category.label }}
        </mat-option>
      }
    </mat-select>
  </pr-input>

  <pr-input
    [hidden]="form.get('category').value != 'CONTRACT'"
    label="Type de document"
    [derrors]="derrors"
  >
    <mat-select
      formControlName="productCategory"
      (selectionChange)="initFormWithProductCategory()"
    >
      @for (
        productCategory of gedProductCategoriesRetreive(
          form.get('category').value
        );
        track productCategory
      ) {
        <mat-option [value]="productCategory.code">
          {{ productCategory.label }}
        </mat-option>
      }
    </mat-select>
  </pr-input>

  <pr-input
    [hidden]="hiddenProductType(form.get('productCategory').value)"
    label="Type de produit"
    [derrors]="derrors"
  >
    <mat-select formControlName="productType">
      @for (
        productType of gedProductTypesRetreive(
          form.get('productCategory').value
        );
        track productType
      ) {
        <mat-option [value]="productType.code">
          {{ productType.label }}
        </mat-option>
      }
    </mat-select>
  </pr-input>

  <pr-input
    label="Partenaire"
    [derrors]="derrors"
    [hidden]="form.get('productCategory').value == null"
  >
    <pr-select-search
      formControlName="providerId"
      label="Partenaire"
      [options]="gedPartners"
    >
    </pr-select-search>
  </pr-input>

  <pr-input
    label="Produit"
    [derrors]="derrors"
    [hidden]="
      form.get('providerId').value == null ||
      !gedProductsRetreive(form.get('providerId').value).length
    "
  >
    <pr-select-search
      formControlName="productId"
      label="Produit"
      [options]="gedProductsRetreive(form.get('providerId').value)"
    >
    </pr-select-search>
  </pr-input>

  <pr-input
    [hidden]="form.get('category').value != 'OTHER'"
    label="Label"
    [derrors]="derrors"
  >
    <input formControlName="label" type="text" />
  </pr-input>

  <pr-input
    [hidden]="
      form.get('category').value == null ||
      form.get('category').value == 'OTHER'
    "
    label="Document"
    [derrors]="derrors"
  >
    <mat-select
      formControlName="document"
      (selectionChange)="initFormWithDocument()"
    >
      @for (
        document of gedDocumentsRetreive(
          form.get('category').value,
          form.get('productCategory').value
        );
        track document
      ) {
        <mat-option [value]="document.code">
          {{ document.label }}
        </mat-option>
      }
    </mat-select>
  </pr-input>

  <!-- <pr-input-date
  [hidden]="form.get('document').value != 'TITRE_DE_SEJOUR' && form.get('document').value != 'CNI' && form.get('document').value != 'PASSEPORT'"
formControlName="dateExpired" label="Date d'expiration" [derrors]="derrors"></pr-input-date> -->

  <pr-input
    [hidden]="form.get('document').value != 'JUSTIFICATIF_DE_DOMICILE'"
    label="Type de document"
    [derrors]="derrors"
  >
    <mat-select formControlName="documentType">
      @for (
        documentType of gedDocumentsTypeRetreive(form.get('document').value);
        track documentType
      ) {
        <mat-option [value]="documentType.code">
          {{ documentType.label }}
        </mat-option>
      }
    </mat-select>
  </pr-input>

  <div
    click-stop-propagation
    class="info"
    [hidden]="!form.get('category').value"
  >
    <pr-icon name="sp-warning" class="info__icon"></pr-icon>
    <p class="info__text">
      Tout document signé et possédant un certificat de signature doit être
      indiqué comme signé sous peine de perte du certificat de signature lors de
      la sauvergarde du document.
    </p>
  </div>

  <pr-input
    [hidden]="!form.get('category').value"
    label="Document signé ?"
    [derrors]="derrors"
  >
    <mat-select formControlName="isSigned">
      <mat-option [value]="true"> Signé </mat-option>
      <mat-option [value]="false"> Non signé </mat-option>
    </mat-select>
  </pr-input>

  <pr-input-date
    [hidden]="
      form.get('document').value != 'TITRE_DE_SEJOUR' &&
      form.get('document').value != 'CNI' &&
      form.get('document').value != 'PASSEPORT'
    "
    formControlName="dateExpired"
    label="Date d'expiration"
    [derrors]="derrors"
  ></pr-input-date>

  <pr-file
    (fileChange)="onLoadFiles($event)"
    [form]="true"
    [fileForm]="file"
  ></pr-file>

  @if (error != null) {
    <div class="alert alert-danger" style="margin-top: 20px" role="alert">
      {{ error }}
    </div>
  }

  @if (isCristalisOrganization) {
    <div class="cristalis-link">
      <a
        href="https://www.cristalis.com/upload/documents/modele_piece_identite_conforme.pdf"
        target="_blank"
        style="text-decoration: underline"
        >Mon document est-il conforme ?</a
      >
    </div>
  }
</pr-form>
